export default "__VITE_ASSET__ui$YqONU__"